<!-- 加入我们 -->
<template>

    <div class="joinbox">
        <Header></Header>
        <div class="banxin">
            <h2>不负春光 不负韶华</h2>
            <p class="txt"> 在这里，你将拥有宽松、愉悦、平等的工作环境，你将收获友爱、尊重、温暖的创业伙伴， 更重要的是，你有可能实现自己最大的价值。</p>
            <ul class="listimg">
                <li class="li1"><img src="https://resource.imbeiyu.com/H5/20200710/guyu (9).jpg" alt=""></li>
                <li class="li2"><img src="https://resource.imbeiyu.com/H5/20200710/shu (1).jpg" alt=""></li>
                <li class="li1"><img src="https://resource.imbeiyu.com/H5/20200710/guyu (10).jpg" alt=""></li>
                <li class="li2"><img src="https://resource.imbeiyu.com/H5/20200710/shu (2).jpg" alt=""></li>
                <li class="li2"><img src="https://resource.imbeiyu.com/H5/20200710/shu (3).jpg" alt=""></li>
                <li class="li1"><img src="https://resource.imbeiyu.com/H5/20200710/guyu (14).jpg" alt=""></li>
                <li class="li2"><img src="https://resource.imbeiyu.com/H5/20200710/shu (4).jpg" alt=""></li>
                <li class="li1"><img src="https://resource.imbeiyu.com/H5/20200710/guyu.png" alt=""></li>

            </ul>
        </div>
        <Footer></Footer>
    </div>
</template>
<script>
import Header from "../../components/header"
import Footer from "../../components/footer"
export default {
    components: {
        Header, Footer
    },
    data() {
        return {

        }
    },
    created() {

    },
    methods: {

    },
}
</script>
<style lang="less" scoped>
.joinbox {
    background: rgba(250, 250, 250, 1);
}

.banxin {
    padding-top: .41rem;

    h2 {
        font-weight: 400;
        width: 100%;
        text-align: center;
        font-size: .25rem;
        color: rgba(51, 51, 51, 1);
    }

    .txt {
        margin: .125rem auto 0 auto;
        color: #999999;
        font-size: .1rem;
        width: 75%;
        text-align: center;
        line-height: 0.2rem;
    }

    .listimg {
        margin: .42rem auto 0 auto;
        width: 100%;
        align-items: center;
        display: flex;
        flex-wrap: wrap;

        li {
            padding: 2px;
            position: relative;
            margin: 0.005rem;

            img {
                width: 100%;
                height: 100%;
            }

            img:hover {
                position: absolute;
                z-index: 4;
                animation: imgscale 1s;
                transform: scale(1.2);
                box-shadow: 0 0 10Px 5Px #fff;
            }

            @keyframes imgscale {

                0%,
                to {
                    transform: scale(1)
                }

                100% {
                    transform: scale(1.2)
                }
            }
        }
    }

    .li1 {
        width: 1.8rem;
        height: 1.1rem;
    }

    .li2 {
        width: 1.3rem;
        height: 1.1rem;
    }
}
</style>


// WEBPACK FOOTER //
// src/page/webpage/joinus.vue